import {routes} from './publicacao.routes';
import PublicacaoListController from "./directory/directory.controller";
import PublicacaoService from "./publicacao.service";
import PublicacaoDetailsController from "./details/details.controller";
import PublicacaoCreatePublicacaoController from "./new/new.controller";

export default angular.module('app.publicacao', [])
  .config(routes)
  .controller('PublicacaoListController', PublicacaoListController)
  .service('PublicacaoService', PublicacaoService)
  .controller('PublicacaoDetailsController', PublicacaoDetailsController)
  .controller('PublicacaoCreatePublicacaoController', PublicacaoCreatePublicacaoController)
  .name;
